import React, { useContext } from "react"

import { Color, Size } from "~tailwindui/types/enums"

import { path } from "~Tutor/TutorRoutes"
import { StyledLink } from "~tailwindui/Basics"
import Timeline from "~tailwindui/Timeline"
import { buttonClassNames } from "~tailwindui/helpers/classNameHelpers"

import dayjs from "src/dayjs"

import TimeProtectedMiroLink from "components/TimeProtectedMiroLink"
import TutorContext from "components/Tutor/TutorContext"
import TutorCloudroomButton from "components/Tutor/components/Sessions/TutorCloudroomButton"

export type ScheduleProps = {
  sessions: any[]
}

function joinSessionButtonDisabled(startsAt: Date): boolean {
  return dayjs().isBefore(dayjs(startsAt).subtract(30, "minutes"))
}

const Schedule: React.FC<ScheduleProps> = ({ sessions }) => {
  const { viewer } = useContext(TutorContext)
  if (sessions.length === 0)
    return <span className="italic text-gray-600">No scheduled sessions</span>

  const sessionEvents = sessions.map((session, idx) => ({
    timestamp: session.startsAt,
    component: (
      <>
        <StyledLink
          to={path("sessionDetails", { id: session.id })}
          className="text-gray-700"
        >
          <span>
            {session.subject?.name} (
            {session.studyGroup
              ? session.studyGroup?.name
              : session.students[0].fullName}
            )
          </span>
        </StyledLink>
        <div className="flex flex-wrap gap-2">
          {idx === 0 && (
            <TutorCloudroomButton
              startsAt={session.startsAt}
              id={session.id}
              disabled={joinSessionButtonDisabled(session.startsAt)}
            />
          )}
          {session.realtimeboards[0] && (
            <TimeProtectedMiroLink
              tailwind
              startsAt={session.startsAt}
              email={viewer.ssoEmail}
              boardId={session.realtimeboards[0].id}
              boardPending={session.realtimeboardPending}
              buttonClassName={buttonClassNames({
                size: Size.Small,
                color: Color.Green,
              })}
            />
          )}
        </div>
      </>
    ),
  }))

  return <Timeline items={sessionEvents} />
}

export default Schedule
